import { DashboardMenu } from "../../data/menu"
import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import changeUrl from "../../hoc/changeur";
import { config } from "../../data/config";
import ImageUploader from "../tools/uploaderImage"
import { useTranslation } from 'react-i18next';
import { QRCodeCanvas } from 'qrcode.react';
import HeaderOfPage from "../tools/headerOfPage";
import { SelectPicker } from 'rsuite';
import { useNavigate } from 'react-router-dom';
import PlusIcon from '@rsuite/icons/Plus';
import ReloadIcon from '@rsuite/icons/Reload';

type LanguageCode = 'ku' | 'fa' | 'en' | 'ar' | 'tr';

interface MultilingualField {
    ku: string;
    fa: string;
    en: string;
    ar: string;
    tr: string;
    [key: string]: string;
}

interface ProductColor {
    name: string;
    hex: string;
    stock: boolean;
}

interface ProductData {
    name: MultilingualField;
    url: MultilingualField;
    keywords: MultilingualField;
    description: MultilingualField;
    parent: string | null;
    code: string;
    sku?: string;
    productCode?: string;
    stock?: number;
    type?: string;
    mainprice: number | null;
    alt?: MultilingualField;
    colors?: ProductColor[];
}

export default function ListPr() {
    const { t } = useTranslation();

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Products',
            url: '/dashboard/Products'
        },
        {
            name: 'List Products',
            url: null
        },
    ]
    const reloadgame = () => {
        let x = key + 1;
        setKey(x);
    }
    const [key, setKey] = useState(1);

    return (
        <>
            <div className="bg-gray-50 min-h-screen p-4 md:p-6">
                <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="List Products"></HeaderOfPage>

                <div className="grid grid-cols-1 gap-6 mt-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <NewProductButton />
                        <ElasticsearchSyncButton />
                    </div>
                    <div className="w-full">
                        <ListofProducts key={key}></ListofProducts>
                    </div>
                </div>
            </div>
        </>
    )
}

function ListofProducts() {
    const { t } = useTranslation();

    let cookie = getCookies();
    const [list, setList] = useState<any>(null);
    const [name, setName] = useState<string>('');
    const [group, setGroup] = useState<string>('');
    const [listgroup, setListArticle] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [activeLang, setActiveLang] = useState<LanguageCode>('en');
    const languages: Array<{ code: LanguageCode; label: string }> = [
        { code: 'ku' as LanguageCode, label: 'Kurdish' },
        { code: 'fa' as LanguageCode, label: 'فارسی' },
        { code: 'en' as LanguageCode, label: 'English' },
        { code: 'ar' as LanguageCode, label: 'العربية' },
        { code: 'tr' as LanguageCode, label: 'Türkçe' }
    ];

    // Helper function to get display name from multilingual or string
    const getDisplayName = (name: any): string => {
        if (!name) return '';
        if (typeof name === 'string') return name;
        if (typeof name === 'object') {
            // Use the selected language, fallback to others if not available
            return name[activeLang] || name.en || name.fa || name.ku || name.ar || name.tr || '';
        }
        return String(name);
    };

    // Helper function to render group options with unlimited levels
    const renderGroupOptions = (groups: any[], level: number = 0, isLast: boolean[] = []): JSX.Element[] => {
        if (!groups || !Array.isArray(groups)) return [];

        return groups.map((group: any, index: number) => {
            const displayName = getDisplayName(group.name);
            const groupId = group._id || group.id;
            const isLastItem = index === groups.length - 1;
            const currentIsLast = [...isLast, isLastItem];

            // Visual indicator for hierarchy levels
            let prefix = '';
            if (level > 0) {
                // Build prefix based on parent levels
                const prefixParts: string[] = [];
                for (let i = 0; i < level - 1; i++) {
                    prefixParts.push(currentIsLast[i] ? '   ' : '│  ');
                }
                prefixParts.push(isLastItem ? '└─ ' : '├─ ');
                prefix = prefixParts.join('');
            }

            const children = group.togroup && Array.isArray(group.togroup) && group.togroup.length > 0
                ? renderGroupOptions(group.togroup, level + 1, currentIsLast)
                : [];

            return (
                <React.Fragment key={groupId}>
                    <option value={groupId}>
                        {prefix}{displayName}
                    </option>
                    {children}
                </React.Fragment>
            );
        });
    };

    const loaddata = async (page = 1) => {
        setLoading(true);
        try {
            let res = await axios({
                method: 'get',
                url: `${config.url}/v1/dashboard/pproducts?page=${page}&name=${name}&group=${group}`,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            let mydata = res.data.message;
            setList(mydata);
            setCurrentPage(page);
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: error.response?.data?.message || t('Error loading products'),
            });
        } finally {
            setLoading(false);
        }
    }

    const getalldata = async () => {
        try {
            // Get all groups without filtering
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/pgroup/getall',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            })

            const allGroups = res.data.message || [];

            // Build tree structure from flat list
            const buildTree = (groups: any[], parentId: string | null = null): any[] => {
                return groups
                    .filter((group: any) => {
                        const groupParent = group.subgroup || null;
                        return (parentId === null && (groupParent === null || groupParent === '')) ||
                            (parentId !== null && groupParent === parentId);
                    })
                    .map((group: any) => {
                        const children = buildTree(groups, group._id || group.id);
                        return {
                            ...group,
                            togroup: children.length > 0 ? children : undefined
                        };
                    })
                    .sort((a: any, b: any) => (a.arranged || 0) - (b.arranged || 0));
            };

            const treeGroups = buildTree(allGroups);
            setListArticle(treeGroups);
        } catch (error: any) {
            console.error('Error loading groups:', error);
        }
    }

    const deleted = async (id: any) => {
        Swal.fire({
            title: t("Are you sure?"),
            text: t("Delete this Product!"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t('Yes, delete it'),
            cancelButtonText: t('Cancel')
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    let res = await axios({
                        method: 'delete',
                        url: config.url + '/v1/dashboard/pproducts/' + id,
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                        }
                    })

                    Swal.fire({
                        icon: 'success',
                        title: t('Deleted'),
                        text: t('Product deleted successfully'),
                        timer: 1500,
                        showConfirmButton: false
                    });

                    loaddata(currentPage);
                } catch (error: any) {
                    Swal.fire({
                        icon: 'error',
                        title: t('Error'),
                        text: error.response?.data?.message || t('Error deleting product'),
                    });
                }
            }
        });
    }

    useEffect(() => {
        loaddata(1);
        getalldata();
    }, []);

    if (loading && !list) {
        return (
            <div className="bg-white rounded-xl shadow-sm p-8">
                <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                </div>
                <p className="text-center mt-4 text-gray-600">در حال بارگذاری...</p>
            </div>
        );
    }

    return (
        <div className="space-y-4" dir="rtl">
            {/* Filters Card */}
            <div className="bg-white rounded-xl shadow-sm p-6">
                <div className="flex items-center justify-between mb-4">
                    <h3 className="text-lg font-semibold text-gray-800">فیلتر و جستجو</h3>
                    {/* Language Selector */}
                    <div className="flex items-center gap-3">
                        <span className="text-sm font-medium text-gray-700">زبان نمایش:</span>
                        <div className="flex gap-2 flex-wrap">
                            {languages.map((lang) => (
                                <button
                                    key={lang.code}
                                    type="button"
                                    onClick={() => setActiveLang(lang.code)}
                                    className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${activeLang === lang.code
                                            ? 'bg-blue-600 text-white'
                                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                        }`}
                                >
                                    {lang.label}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            نام محصول
                        </label>
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                            placeholder="جستجو بر اساس نام..."
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            گروه
                        </label>
                        <select
                            value={group}
                            onChange={(e) => setGroup(e.target.value)}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                        >
                            <option value="">همه گروه‌ها</option>
                            {listgroup != null && Array.isArray(listgroup) && listgroup.length > 0 && renderGroupOptions(listgroup)}
                        </select>
                    </div>
                    <div className="flex items-end">
                        <button
                            onClick={() => loaddata(1)}
                            className="w-full px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
                        >
                            اعمال فیلتر
                        </button>
                    </div>
                </div>
            </div>

            {/* Products Table */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th scope="col" className="px-6 py-4 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    {t('Name')}
                                </th>
                                <th scope="col" className="px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    {t('Firstpage')}
                                </th>
                                <th scope="col" className="px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    {t('Action')}
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {list && list.docs && list.docs.length > 0 ? (
                                list.docs.map((item: any) => {
                                    const badges = [];
                                    if (item.firstpage == 1) badges.push({ text: 'صفحه اول', color: 'bg-purple-100 text-purple-800' });
                                    if (item.special == 1) badges.push({ text: 'پرفروش', color: 'bg-green-100 text-green-800' });
                                    if (item.special1 == 1) badges.push({ text: 'جدیدترین', color: 'bg-blue-100 text-blue-800' });
                                    if (item.special2 == 1) badges.push({ text: 'ویژه', color: 'bg-yellow-100 text-yellow-800' });

                                    return (
                                        <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                                            <td className="px-6 py-4">
                                                <div className="flex items-start">
                                                    <div className="flex-1">
                                                        <div className="text-sm font-medium text-gray-900">
                                                            {getDisplayName(item.name)}
                                                        </div>
                                                        {item.toGroup && (
                                                            <div className="text-sm text-gray-500 mt-1">
                                                                <span className="inline-flex items-center gap-1">
                                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                                                                    </svg>
                                                                    گروه: {getDisplayName(item.toGroup.name)}
                                                                </span>
                                                            </div>
                                                        )}
                                                        <div className="text-xs text-yellow-600 mt-1 font-mono">
                                                            {getDisplayName(item.url)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4">
                                                <div className="flex flex-wrap items-center justify-center gap-2">
                                                    {badges.length > 0 ? (
                                                        badges.map((badge, idx) => (
                                                            <span
                                                                key={idx}
                                                                className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${badge.color}`}
                                                            >
                                                                {badge.text}
                                                            </span>
                                                        ))
                                                    ) : (
                                                        <span className="text-gray-400 text-sm">-</span>
                                                    )}
                                                </div>
                                            </td>
                                            <td className="px-6 py-4">
                                                <div className="flex items-center justify-center gap-2">

                                                    <a
                                                        href={`/dashboard/Products/Products/${item.id}`}
                                                        className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-green-600 bg-green-50 rounded-lg hover:bg-green-100 transition-colors"
                                                        title="ویرایش"
                                                    >
                                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                        </svg>
                                                    </a>
                                                    <button
                                                        onClick={() => deleted(item.id)}
                                                        className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-red-600 bg-red-50 rounded-lg hover:bg-red-100 transition-colors"
                                                        title="حذف"
                                                    >
                                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={3} className="px-6 py-12 text-center">
                                        <div className="flex flex-col items-center">
                                            <svg className="w-16 h-16 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                                            </svg>
                                            <p className="text-gray-500 text-lg">محصولی یافت نشد</p>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                {list && list.totalPages > 1 && (() => {
                    const currentPage = list.page;
                    const totalPages = list.totalPages;
                    const maxPagesToShow = 10;

                    // Function to generate page numbers to display
                    const getPageNumbers = (): (number | string)[] => {
                        if (totalPages <= maxPagesToShow) {
                            // Show all pages if total is less than or equal to max
                            return Array.from({ length: totalPages }, (_, i) => i + 1);
                        }

                        const pages: (number | string)[] = [];
                        const sidePages = Math.floor((maxPagesToShow - 3) / 2); // Pages on each side of current

                        // Always show first page
                        pages.push(1);

                        let startPage = Math.max(2, currentPage - sidePages);
                        let endPage = Math.min(totalPages - 1, currentPage + sidePages);

                        // Adjust if we're near the start
                        if (currentPage <= sidePages + 1) {
                            endPage = Math.min(totalPages - 1, maxPagesToShow - 1);
                        }

                        // Adjust if we're near the end
                        if (currentPage >= totalPages - sidePages) {
                            startPage = Math.max(2, totalPages - (maxPagesToShow - 2));
                        }

                        // Add ellipsis after first page if needed
                        if (startPage > 2) {
                            pages.push('ellipsis-start');
                        }

                        // Add pages around current
                        for (let i = startPage; i <= endPage; i++) {
                            pages.push(i);
                        }

                        // Add ellipsis before last page if needed
                        if (endPage < totalPages - 1) {
                            pages.push('ellipsis-end');
                        }

                        // Always show last page
                        if (totalPages > 1) {
                            pages.push(totalPages);
                        }

                        return pages;
                    };

                    const pageNumbers = getPageNumbers();

                    return (
                        <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
                            <div className="flex items-center justify-between">
                                <div className="text-sm text-gray-700">
                                    نمایش {((list.page - 1) * list.limit) + 1} تا {Math.min(list.page * list.limit, list.totalDocs)} از {list.totalDocs} محصول
                                </div>
                                <nav className="flex items-center gap-2">
                                    {list.prevPage && (
                                        <button
                                            onClick={() => loaddata(list.page - 1)}
                                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                                        >
                                            قبلی
                                        </button>
                                    )}
                                    {pageNumbers.map((pageNum, index) => {
                                        if (pageNum === 'ellipsis-start' || pageNum === 'ellipsis-end') {
                                            return (
                                                <span key={`ellipsis-${index}`} className="px-2 text-gray-500">
                                                    ...
                                                </span>
                                            );
                                        }
                                        return (
                                            <button
                                                key={pageNum}
                                                onClick={() => loaddata(pageNum as number)}
                                                className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${list.page === pageNum
                                                        ? 'bg-blue-600 text-white'
                                                        : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
                                                    }`}
                                            >
                                                {pageNum}
                                            </button>
                                        );
                                    })}
                                    {list.nextPage && (
                                        <button
                                            onClick={() => loaddata(list.page + 1)}
                                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                                        >
                                            بعدی
                                        </button>
                                    )}
                                </nav>
                            </div>
                        </div>
                    );
                })()}
            </div>
        </div>
    )
}

function NewProductButton() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleCreateProduct = () => {
        navigate('/dashboard/Products/Products/new');
    };

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="text-center">
                <div className="mb-4">
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-3">
                        <PlusIcon style={{ width: 32, height: 32 }} className="text-blue-600" />
                    </div>
                    <h3 className="text-xl font-bold text-gray-800 mb-2">
                        {t('Add New Product')} / افزودن محصول جدید
                    </h3>
                    <p className="text-gray-600 text-sm mb-6">
                        برای ثبت محصول جدید، فرم کامل را باز کنید
                        <br />
                        Click to open the full product registration form
                    </p>
                </div>
                <button
                    onClick={handleCreateProduct}
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-4 px-6 rounded-xl transition-all duration-200 transform hover:scale-105 hover:shadow-lg flex items-center justify-center gap-3"
                >
                    <PlusIcon style={{ width: 24, height: 24 }} />
                    <span className="text-lg">باز کردن فرم ثبت محصول / Open Product Form</span>
                </button>
            </div>
        </div>
    );
}

function ElasticsearchSyncButton() {
    const { t } = useTranslation();
    const cookie = getCookies();
    const [syncing, setSyncing] = useState(false);

    const handleSync = async () => {
        const result = await Swal.fire({
            title: 'همگام‌سازی با Elasticsearch',
            text: 'آیا می‌خواهید تمام محصولات را با موتور جستجو همگام‌سازی کنید؟ این ممکن است چند دقیقه طول بکشد.',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'بله، همگام‌سازی کن',
            cancelButtonText: 'لغو',
            confirmButtonColor: '#10b981',
        });

        if (!result.isConfirmed) return;

        setSyncing(true);
        try {
            const response = await axios.post(
                `${config.url}/v1/dashboard/pproducts/sync-elasticsearch`,
                {},
                {
                    headers: {
                        Authorization: 'Bearer ' + cookie['token'],
                    }
                }
            );

            await Swal.fire({
                icon: 'success',
                title: 'موفق!',
                html: `
                    <div style="text-align: center;">
                        <p><strong>${response.data.synced}</strong> محصول با موفقیت همگام‌سازی شد</p>
                        <p class="text-sm text-gray-600 mt-2">
                            ${response.data.synced} of ${response.data.total} products synced successfully
                        </p>
                    </div>
                `,
                timer: 3000,
            });
        } catch (error: any) {
            console.error('Sync error:', error);
            await Swal.fire({
                icon: 'error',
                title: 'خطا!',
                text: error.response?.data?.message || 'خطا در همگام‌سازی با Elasticsearch',
            });
        } finally {
            setSyncing(false);
        }
    };

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="text-center">
                <div className="mb-4">
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-3">
                        <ReloadIcon style={{ width: 32, height: 32 }} className="text-green-600" />
                    </div>
                    <h3 className="text-xl font-bold text-gray-800 mb-2">
                        همگام‌سازی جستجو / Sync Search
                    </h3>
                    <p className="text-gray-600 text-sm mb-6">
                        همگام‌سازی مجدد محصولات با Elasticsearch
                        <br />
                        Re-sync all products with search engine
                    </p>
                </div>
                <button
                    onClick={handleSync}
                    disabled={syncing}
                    className="w-full bg-green-600 hover:bg-green-700 disabled:bg-gray-400 text-white font-semibold py-4 px-6 rounded-xl transition-all duration-200 transform hover:scale-105 hover:shadow-lg flex items-center justify-center gap-3"
                >
                    {syncing ? (
                        <>
                            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white"></div>
                            <span className="text-lg">در حال همگام‌سازی...</span>
                        </>
                    ) : (
                        <>
                            <ReloadIcon style={{ width: 24, height: 24 }} />
                            <span className="text-lg">همگام‌سازی / Sync Now</span>
                        </>
                    )}
                </button>
            </div>
        </div>
    );
}

// Old NewProductForm has been removed and replaced with simple NewProductButton above
